import { render, staticRenderFns } from "./LocalInformation.vue?vue&type=template&id=296d3c9e"
import script from "./LocalInformation.vue?vue&type=script&lang=js"
export * from "./LocalInformation.vue?vue&type=script&lang=js"
import style0 from "./LocalInformation.vue?vue&type=style&index=0&id=296d3c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports